import { Injectable } from '@angular/core';

import { GDPRLinkToken } from '@core/wysiwyg-legacy';

@Injectable({ providedIn: 'root' })
export class EmailHtmlProcessor {
  public processHtmlForEmail(html: string, isEdit: boolean = false): string {
    const resultReplaceHtmlTags = this.replaceHtmlTags(html);
    return isEdit ? resultReplaceHtmlTags : this.replaceGdprLinkToToken(resultReplaceHtmlTags);
  }

  public replaceHtmlTags(html: string): string {
    return (
      html
        // add target blank
        .replace(/<a([^>]+)>/g, '<a target="_blank" $1>')
        // replace <p> with <div class="rt-paragraph"> & transfer other attributes
        .replace(/<p(.*?)>(.*?)<\/p>/gi, (_, attributesMatch, textMatch) => {
          const hasClass = attributesMatch.includes('class="');
          const attributes = hasClass
            ? attributesMatch.replace('class="', 'class="rt-paragraph ')
            : ` class="rt-paragraph"${attributesMatch}`;
          return `<div${attributes}>${textMatch}</div>`;
        })
        // replace p in selectors with .rt-paragraph
        .replace(/<style>([\s\S]*?)<\/style>/gm, styleGroup =>
          styleGroup.replace(/(^|[ >+~])p(?=($|[ .>+~:{]))/gm, match =>
            match.replace('p', '.rt-paragraph'),
          ),
        )
    );
  }

  private replaceGdprLinkToToken(html: string): string {
    return html.replace(/href="(.*?)"/g, (substring, url) => {
      if (/http.*?\/gdpr\/candidates\/.*?\/requests\/removal/g.test(url)) {
        return substring.replace(url, GDPRLinkToken.GdprRemove);
      }
      if (/http.*?\/gdpr\/candidates\/.*?\/requests\/change/g.test(url)) {
        return substring.replace(url, GDPRLinkToken.GdprChange);
      }

      return substring;
    });
  }
}
